/**
 * Clear all service worker caches and registrations
 * Useful when switching domains or resolving CORS issues
 */
export const clearAllServiceWorkerData = async (): Promise<void> => {
  if ("serviceWorker" in navigator) {
    try {
      // Unregister all service workers
      const registrations = await navigator.serviceWorker.getRegistrations();

      for (const registration of registrations) {
        console.log(
          `Unregistering service worker with scope: ${registration.scope}`
        );
        await registration.unregister();
      }

      // Clear all caches
      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(async (cacheName) => {
            console.log(`Deleting cache: ${cacheName}`);
            return caches.delete(cacheName);
          })
        );
      }

      console.log("All service worker data cleared successfully");
    } catch (error) {
      console.error("Error clearing service worker data:", error);
    }
  }
};

/**
 * Force reload the service worker and refresh the page
 */
export const reloadServiceWorker = async (): Promise<void> => {
  if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
    // Send a message to the service worker to skip waiting and reload
    navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
  }

  // Reload the page after a short delay
  setTimeout(() => {
    window.location.reload();
  }, 500);
};

/**
 * Check if current domain matches service worker scope
 * Useful for detecting CORS issues with Azure Static Web Apps custom domains
 */
export const checkServiceWorkerDomainMatch = (): Promise<boolean> => {
  if (!("serviceWorker" in navigator)) {
    return Promise.resolve(false);
  }

  return navigator.serviceWorker.getRegistrations().then((registrations) => {
    let hasMatch = true;

    registrations.forEach((registration) => {
      const swScope = new URL(registration.scope);
      const currentDomain = window.location.origin;

      if (swScope.origin !== currentDomain) {
        console.warn(
          `Service Worker domain mismatch: SW scope is ${swScope.origin}, current domain is ${currentDomain}`
        );
        hasMatch = false;
      }
    });

    return hasMatch;
  });
};
